module.exports = __webpack_public_path__ + "a5401224180f32a1f43c5681f8f22fc4.svg";